import * as Models from "../ts/rlAdmin.models";
import { RLBaseService } from "./rl-base-service";
import { ICustomUserColumn } from "../ts/rlAdmin.models";

export class ReportService extends RLBaseService {
   
    getReportParameters(reportName: string) {
        var query = { reportName: reportName };
        return this.toRLService<Models.IReportParameter>("/api/report/getreportparameters").getArray(query).$promise;
    }

    getReportParameterMapping() {
        return this.toRLService<Models.IDictionaryS<string>>("/api/report/getreportparametermapping").get().$promise;
    }

    executeReportOffline(reportName: string, reportParameters: Models.IReportParameter[]) {
        var data = { reportName: reportName, reportParameters: reportParameters };
        return this.toRLService<Models.IJobResponse>("/api/report/executereportoffline").post(data).$promise;
    }
    getReportList() {
        return this.toRLService<Models.IReport>("/api/report/getreportlist").getArray().$promise;
    }

    dynamicReport(query) {
        return this.toRLService<Models.IDynamicReportResults>("/api/report/dynamicreport").post(query).$promise;
    }

    exportReport(query) {
        return this.toRLService<boolean>("/api/report/exportreport").post(query).$promise;
    }

    viewReport(reportName: string, reportPath: string, reportParameters: Models.IReportParameter[]): any {
        var data = { reportName: reportName, reportPath: reportPath, reportParametersWithValues: reportParameters };
        return this.toRLService<any>("/api/report/reportviewer").post(data).$promise;

    }
    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getPropertyAvailsRows(entityID: string, territoryId: number, startDate: string, endDate: string) {
        return this.toRLService<Models.IPropertyAvailability>("/api/report/getpropertyavailsrows").query({ entityID: entityID, territoryId: territoryId || -1, startDate: startDate || "", endDate: endDate || "" }).$promise;
    }

    getRows(territoryId: number, startDate: string, endDate: string) {
        return this.toRLService<Models.IPropertyAvailability>("/api/report/getrows").query({ territoryId: territoryId || -1, startDate: startDate || "", endDate: endDate || "" }).$promise;
    }

    getAvailabilityWindowProperties(exactInd: number, exclusive: number, isWindowed: boolean,
        startDate: string, endDate: string, territoryIDs: number[],
        mediaIDs: number[], channelIDs: number[], languageIDs: number[],
        titleQuery: string, assetIDs: number[], assetFacets: { [key: string]: string[] },
        page: number, rows: number, rollup: number) {

        var query = {
            exactInd: exactInd,
            exclusive: exclusive,
            isWindowed: isWindowed,
            startDate: startDate,
            endDate: endDate,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            page: page,
            rows: rows,
            titleQuery: titleQuery,
            assetFacets: assetFacets,
            propertyIDs: assetIDs,
            rollup: 0
        };

        return this.toRLService<Models.ISearchResults<Models.IEntitySearchDoc>>("/api/report/GetAvailabilityProperties").post(query).$promise;
    }

    getAvailabilityWindows(assetIDs: number[], assetFacets: { [key: string]: string[] }, startDate: string, endDate: string, dim1ValueIDs: number[], dim2ValueIDs: number[], dim3ValueIDs: number[], dim4ValueIDs: number[], isExclusive: boolean, isExact: boolean, isWindowed: boolean, isAssetAvailable: boolean, isTupleAvailable: boolean, isScoped: boolean, rollupDim: number, minDays: number, matchType: number, truncateWindows: boolean, dimFormatFlag: number, offset: number, limit: number, assetUserColumns: ICustomUserColumn[]) {
        var query = {
            assetIDs,
            assetFacets,
            startDate,
            endDate,
            dim1ValueIDs,
            dim2ValueIDs,
            dim3ValueIDs,
            dim4ValueIDs,
            isExclusive,
            isExact,
            isWindowed,
            isAssetAvailable,
            isTupleAvailable,
            isScoped,
            rollupDim,
            minDays,
            matchType,
            offset,
            limit,
            assetUserColumns,
            truncateWindows,
            dimFormatFlag
        };

        return this.toRLService<{ reportID: string }>("/api/report/getavailabilitywindows").post(query).$promise;
    }

    exportAvailabilityWindows(assetIDs: number[], assetFacets: { [key: string]: string[] }, startDate: string, endDate: string, dim1ValueIDs: number[], dim2ValueIDs: number[], dim3ValueIDs: number[], dim4ValueIDs: number[], isExclusive: boolean, isExact: boolean, isWindowed: boolean, isAssetAvailable: boolean, isTupleAvailable: boolean, isScoped: boolean, rollupDim: number, minDays: number, matchType: number, assetUserColumns: ICustomUserColumn[], truncateWindows: boolean, dimFormatFlag: number) {
        var query = {
            assetIDs,
            assetFacets,
            startDate,
            endDate,
            dim1ValueIDs,
            dim2ValueIDs,
            dim3ValueIDs,
            dim4ValueIDs,
            isExclusive,
            isExact,
            isWindowed,
            isAssetAvailable,
            isTupleAvailable,
            isScoped,
            rollupDim,
            minDays,
            matchType,
            assetUserColumns,
            truncateWindows,
            dimFormatFlag
        };

        return this.toRLService<Models.IJobResponse>("/api/report/exportavailabilitywindows").post(query).$promise;
    }

    getAvailabilityWindowAssets(assetIDs: number[], assetFacets: { [key: string]: string[] }, startDate: string, endDate: string, dim1ValueIDs: number[], dim2ValueIDs: number[], dim3ValueIDs: number[], dim4ValueIDs: number[], isExclusive: boolean, isExact: boolean, isWindowed: boolean, isAssetAvailable: boolean, minDays: number, matchType: number, offset: number, limit: number, assetUserColumns: ICustomUserColumn[]) {
        var query = {
            assetIDs,
            assetFacets,
            startDate,
            endDate,
            dim1ValueIDs,
            dim2ValueIDs,
            dim3ValueIDs,
            dim4ValueIDs,
            isExclusive,
            isExact,
            isWindowed,
            isAssetAvailable,
            minDays,
            matchType,
            offset,
            limit,
            assetUserColumns
        };

        return this.toRLService<{ reportID: string }>("/api/report/GetAvailabilityWindowAssets").post(query).$promise;
    }

    exportAvailabilityWindowAssets(assetIDs: number[], assetFacets: { [key: string]: string[] }, startDate: string, endDate: string, dim1ValueIDs: number[], dim2ValueIDs: number[], dim3ValueIDs: number[], dim4ValueIDs: number[], isExclusive: boolean, isExact: boolean, isWindowed: boolean, isAssetAvailable: boolean, minDays: number, matchType: number, assetUserColumns: ICustomUserColumn[]) {
        var query = {
            assetIDs,
            assetFacets,
            startDate,
            endDate,
            dim1ValueIDs,
            dim2ValueIDs,
            dim3ValueIDs,
            dim4ValueIDs,
            isExclusive,
            isExact,
            isWindowed,
            isAssetAvailable,
            minDays,
            matchType,
            assetUserColumns
        };

        return this.toRLService<Models.IJobResponse>("/api/report/exportavailabilitywindowassets").post(query).$promise;
    }

    getCatalogAvailsIDs(exactInd: number, exclusive: number, isWindowed: boolean,
        startDate: string, endDate: string, territoryIDs: number[],
        mediaIDs: number[], channelIDs: number[], languageIDs: number[],
        titleQuery: string, assetIDs: number[], assetFacets: { [key: string]: string[] },
        page: number, rows: number, rollup: number) {

        var query = {
            exactIndicator: exactInd,
            exclusive: exclusive,
            isWindowed: isWindowed,
            startDate: startDate,
            endDate: endDate,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            page: page,
            rows: rows,
            titleQuery: titleQuery,
            assetFacets: assetFacets,
            propertyIDs: assetIDs,
            rollup: rollup
        };

        return this.toRLService<number>("/api/report/GetCatalogAvailsIDs").postArray(query).$promise;
    }

    getRightsDeals(exactInd: number, startDate: string, endDate: string, territoryIDs: number[], mediaIDs: number[], channelIDs: number[],
        languageIDs: number[], templateIDs: number, statusIDs: number, titleQuery: string,
        page: number, rows: number, queryFields: string[]) {

        var query = {
            charTypeID: 4,
            exactInd: exactInd,
            startDate: startDate,
            endDate: endDate,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            templateIDs: [templateIDs],
            statusIDs: [statusIDs],
            page: page,
            rows: rows,
            queryFields: queryFields,
            titleQuery: titleQuery
        };

        return this.toRLService<Models.ISearchResults<Models.IEntitySearchDoc>>("/api/report/getrightsdeals").post(query).$promise;
    }

    getAssetSearchFacets(facetFields: string[]) {
        var data = {
            facetFields: facetFields
        };
        return this.toRLService<Models.IFacetResults>("/api/report/getassetsearchfacets").post(data).$promise;
    }

    getAssetLovTags() {
        return this.toRLService<Models.IDictionaryS<string>>("/api/report/getassetlovtags").get().$promise;
    }

    getAvailTimeline(startDate: string, endDate: string, assetIDs: number[], assetFacets: { [key: string]: string[] }, exclusive: boolean, exactInd: number, isWindowed: boolean, rightSetTemplateIDs: number[], territoryIDs: number[], mediaIDs: number[], channelIDs: number[], languageIDs: number[], minDays: number, matchType: number, offset: number, limit: number) {
        var data = {
            startDate: startDate,
            endDate: endDate,
            assetIDs: assetIDs,
            assetFacets: assetFacets,
            exclusive: exclusive,
            exactInd: exactInd,
            isWindowed: isWindowed,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            rightSetTemplateIDs: rightSetTemplateIDs,
            minDays: minDays,
            matchType: matchType,
            offset: offset,
            limit: limit
        };
        return this.toRLService<{ reportID: string }>("/api/report/getavailtimeline").post(data).$promise;
    }

    getAvailSearchDetail(dealID: number, rightSetID: number) {
        var data = {
            dealID: dealID,
            rightSetID: rightSetID
        };
        return this.toRLService<Models.IAvailSearchDetailResponse>("/api/report/getavailsearchdetail").post(data).$promise;
    }

    getPropertyCoverage(startDate: string, endDate: string, territoryIDs: number[], mediaIDs: number[], languageIDs: number[], channelIDs: number[], charID: number) {
        var data = {
            startDate: startDate,
            endDate: endDate,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            languageIDs: languageIDs,
            channelIDs: channelIDs,
            charID: charID
        };
        return this.toRLService<Models.IPropertyCoverageWindow>("/api/report/getpropertycoverage").postArray(data).$promise;
    }

    getCustomReport(reportName: string, page: number, rowCount: number) {
        var data = {
            reportName: reportName,
            page: page,
            rowCount: rowCount
        }

        return this.toRLService<any>("/api/report/GetCustomReport").get(data).$promise;
    }

    getCatalogAvailsItems(startDate: string, endDate: string, assetIDs: number[], assetFacets: { [key: string]: string[] }, exclusive: boolean, exactInd: number, isWindowed: boolean, territoryIDs: number[], mediaIDs: number[], channelIDs: number[], languageIDs: number[], minDays: number, matchType: number, start: number, rows: number, sortField: string, sortDir: number) {
        var data = {
            startDate: startDate,
            endDate: endDate,
            assetIDs: assetIDs,
            assetFacets: assetFacets,
            exclusive: exclusive,
            exactInd: exactInd,
            isWindowed: isWindowed,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            minDays: minDays,
            matchType: matchType,
            start: start,
            rows: rows,
            sortField: sortField,
            sortDir: sortDir
        };
        return this.toRLService<{ reportID: string }>("/api/report/getcatalogavailsitems").post(data).$promise;
    }

    addAssetsToWorksheet(worksheetID: string, assetIDs: number[]) {
        var data = {
            worksheetID: worksheetID,
            assetIDs: assetIDs
        };
        return this.toRLService<void>("/api/report/addassetstocatalogavailsworksheet").post(data).$promise;
    }

    getCatalogAvailsWorksheetRows(worksheetID: string, rows: number, start: number) {
        var data = {
            worksheetID: worksheetID,
            rows: rows,
            start: start
        };
        return this.toRLService<Models.IGetCatalogAvailsWorksheetRowsResponse>("/api/report/getcatalogavailsworksheetrows").get(data).$promise;
    }

    removeAssetsFromCatalogAvailsWorksheet(worksheetID: string, assetIDs: number[], deleteAll: boolean) {
        var data = {
            worksheetID: worksheetID,
            assetIDs: assetIDs,
            deleteAll: deleteAll
        };
        return this.toRLService<void>("/api/report/removeassetsfromcatalogavailsworksheet").post(data).$promise;
    }

    addAssetSearchToCatalogAvailsWorksheet(worksheetID: string, startDate: string, endDate: string, assetIDs: number[], assetFacets: { [key: string]: string[] }, exclusive: boolean, exactInd: number, isWindowed: boolean, territoryIDs: number[], mediaIDs: number[], channelIDs: number[], languageIDs: number[], minDays: number, matchType: number) {
        var data = {
            worksheetID: worksheetID,
            startDate: startDate,
            endDate: endDate,
            assetIDs: assetIDs,
            assetFacets: assetFacets,
            exclusive: exclusive,
            exactInd: exactInd,
            isWindowed: isWindowed,
            territoryIDs: territoryIDs,
            mediaIDs: mediaIDs,
            channelIDs: channelIDs,
            languageIDs: languageIDs,
            minDays: minDays,
            matchType: matchType
        };
        return this.toRLService<Models.IJobResponse>("/api/report/addassetsearchtocatalogavailsworksheet").post(data).$promise;
    }

    associateChildEntitiesToParentEntity(targetEntityID: string, worksheetID: string, childEntityIds: string[], allWorksheetAssets: boolean) {
        var data = {
            targetEntityID: targetEntityID,
            worksheetID: worksheetID,
            childEntityIds: childEntityIds,
            allWorksheetAssets: allWorksheetAssets
        };
        return this.toRLService<Models.IJobResponse>("/api/report/associatechildentitiestoparententity").post(data).$promise;
    }

    associateChildEntitiesToNewParentEntity(targetTemplateID: string, worksheetID: string, childEntityIds: string[], allWorksheetAssets: boolean) {
        var data = {
            targetTemplateID: targetTemplateID,
            worksheetID: worksheetID,
            childEntityIds: childEntityIds,
            allWorksheetAssets: allWorksheetAssets
        };
        return this.toRLService<Models.IJobResponse>("/api/report/associatechildentitiestonewparententity").post(data).$promise;
    }

    getCatalogAvailsAssociableParentCharTypes(assetTemplateIDs: number[], worksheetID: string) {
        var data = {
            assetTemplateIDs: assetTemplateIDs,
            worksheetID: worksheetID
        };
        return this.toRLService<{ [charTypeID: number]: string }>("/api/report/getcatalogavailsassociableparentchartypes").post(data).$promise;
    }

    getCatalogAvailsAssociableParentTemplates(parentCharTypeID: number, assetTemplateIDs: number[], worksheetID: string) {
        var data = {
            parentCharTypeID: parentCharTypeID,
            assetTemplateIDs: assetTemplateIDs,
            worksheetID: worksheetID
        };
        return this.toRLService<Models.ICharacteristicTemplate>("/api/report/getcatalogavailsassociableparenttemplates").postArray(data).$promise;
    }

    ExportAvailabilityProperties(query: any) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/ExportAvailabilityProperties").post(query).$promise;
    }

    ExportAvailsWindows(query: any) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/ExportAvailsWindows").post(query).$promise;
    }

    ExportCatalogAvailabilityProperties(query: any) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/ExportCatalogAvailabilityProperties").post(query).$promise;
    }

    isCharacteristicOnAdHocReport(charTypeId: number, characteristicId: number) {
        var args = {
            charTypeId: charTypeId,
            characteristicId: characteristicId
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/IsCharacteristicOnAdHocReport").get(args).$promise;
    }

    getAdHocTreeFilter(fullColumnName: string) {
        var args = {
            fullColumnName: fullColumnName
        };
        return this.toRLService<Models.IDataResponse<Models.IAdHocFilterTreeNode[]>>("/api/report/getAdHocTreeFilter").get(args).$promise;
    }

    // starts the repeating background lookups, resolves/rejects the promise
    getBackgroundReportResults<T>(reportID: string, statusChanged?: (status: string) => void) {
        let deffered = this.$q.defer<T>();
        let lastStatus = "";
        let attempts = 0;

        let query = (rID: string) => {
            attempts++;
            this.toRLService<Models.IBackgroundReportResults<T>>("/api/report/GetBackgroundReportResults").get({ reportID }).$promise
                .then((results) => {
                    if (statusChanged != null && results.status != lastStatus) {
                        statusChanged(results.status);
                        lastStatus = results.status;
                    }
                    switch (results.status) {
                        case "done":
                            deffered.resolve(results.data);
                            break;
                        case "error":
                            deffered.reject(results.message);
                            break;
                        default:
                            let timeout = 500;
                            if (attempts < 5) {
                                timeout = 500;
                            } else if (attempts < 10) {
                                timeout = 2000;
                            } else if (attempts < 100) {
                                timeout = 5000;
                            } else {
                                timeout = 10000;
                            }
                            setTimeout(() => query(rID), timeout);
                            break;
                    }
                })
                .catch((reason) => {
                    deffered.reject(reason);
                });
        };
        query(reportID);
        return deffered.promise;
    }

    moveSavedReportsFromLocalStorageToDB(allSavedReports: Models.ISaveReportCriteria[]) {
        var data = {
            SavedReportCriterias: allSavedReports
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/moveSavedReportsFromLocalStorageToDB").post(data).$promise;
    }

    getSavedReportsList(nameSpace: string, reportName: string, isGlobal: number) {
        var data = {
            nameSpace: nameSpace,
            reportName: reportName,
            isGlobal: isGlobal
        };
        return this.toRLService<Models.ISaveReportCriteria>("/api/report/getSavedReportsList").get(data).$promise;
    }

    saveReportCriteria(reportCriteria: Models.ISaveReportCriteria) {
        var data = {
            reportCriteria: reportCriteria
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/saveReportCriteria").post(data).$promise;
    }

    deleteReportCriteria(reportCriteria: Models.ISaveReportCriteria) {
        var data = {
            reportCriteria: reportCriteria
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/report/deleteReportCriteria").post(data).$promise;
    }
}


